import {useFetch} from "../helpers/APIHelper";
import Loading from "../components/Loading";
import Error from "../components/Error";
import React from "react";
import Post from "../components/Blog/Post";

function Blog() {
    const {data, loading, error} = useFetch({endpoint: "/blog"});

    if (loading) {
        return <Loading/>;
    }

    if (error) {
        return <Error error={error}/>;
    }

    const posts = data.data;

    return (
        <section className="container mx-auto w-4/5 flex flex-col gap-10">
            {posts.map((post, index) => (
                <Post key={index} title={post.title} content={post.content} creation={post.created_at} author={post.author} />
            ))}
        </section>
    );
}

export default Blog;